// extracted by mini-css-extract-plugin
export default {"mainWrapper":"PaidStamp_mainWrapper__dOgDX"};